import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Cycle = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="m14.733 8-2.685 2.684L9.243 7.88a3 3 0 0 0-4.243 0L2.879 10a3 3 0 0 0 0 4.243L5 16.364a3 3 0 0 0 4.243 0l2.684-2.684 2.806 2.805a3 3 0 0 0 4.242 0l2.122-2.121a3 3 0 0 0 0-4.243L18.975 8a3 3 0 0 0-4.242 0ZM7.828 9.293l2.806 2.806-2.806 2.85a1 1 0 0 1-1.414 0l-2.121-2.12a1 1 0 0 1 0-1.415l2.121-2.121a1 1 0 0 1 1.414 0Zm5.513 2.972 2.806-2.85a1 1 0 0 1 1.414 0l2.121 2.12a1 1 0 0 1 0 1.415l-2.12 2.121a1 1 0 0 1-1.415 0l-2.806-2.806Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Cycle;
